import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from 'react-icons/io';
import LogoAlt from '../../../assets/logoAlt.svg';
import '../FeaturedPosts/FeaturedPosts.css';

const RelatedStories = ({ posts = [] }) => {
  if (!posts.length) return null;

  return (
    <section className="related-stories">
      <div className="page-container">
        <h2>Related Stories</h2>
        <div className="related-stories-grid">
          {posts.map((post) => (
            <article key={post.id} className="featured-card">
              <div className="featured-card-meta">
                <span className="featured-date">{post.date}</span>
                <span className="featured-category">
                  <span className="category-dot" aria-hidden="true" />
                  {post.category}
                </span>
              </div>
              <Link to={`/blog/${post.slug}`} className="featured-card-image">
                {post.image ? <img src={post.image} alt="" /> : null}
              </Link>
              <Link to={`/blog/${post.slug}`} className="featured-card-title">
                {post.title}
              </Link>
              {post.summary ? (
                <p className="featured-card-excerpt">{post.summary}</p>
              ) : null}
              <div className="featured-card-footer">
                <div className="featured-author">
                  <img src={LogoAlt} alt="" className="featured-avatar" />
                  <span>{post.author}</span>
                </div>
                <Link
                  to={`/blog/${post.slug}`}
                  className="featured-arrow"
                  aria-label={`Read ${post.title}`}
                >
                  <IoIosArrowForward />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedStories;
